import type { Command } from 'common/Prose/Commands'
import { combineCommands } from 'common/Prose/utils/combineCommands'
import { schema } from 'prose-core'
import { splitListItem } from 'prosemirror-schema-list'

/**
 * If your cursor is inside a `vote_list_item` and you press enter, split the vote_list_item in two
 */
export const splitVoteListItem: Command = (state, dispatch) => {
  if (state.selection.$from.depth < 3) return false // we can't possibly be inside a vote_list_item, bail early
  if (state.selection.$from.node()?.content.size === 0) return false // we're inside a vote_list_item, but it's empty, let the next command handle it
  const tr = combineCommands(state, [splitListItem(schema.nodes.vote_list_item), clearVotersFromVoteListItem])
  if (tr) {
    dispatch?.(tr)
    return true
  }
  return false
}

/**
 * When splitting a `vote_list_item`, clear the voters from the newly created item
 */
const clearVotersFromVoteListItem: Command = (state, dispatch) => {
  const { selection, tr } = state
  const splitListItemPos = selection.$from.before(-1)
  const splitListItemNode = state.doc.resolve(splitListItemPos).nodeAfter
  if (splitListItemNode && splitListItemNode.type === schema.nodes.vote_list_item) {
    dispatch?.(tr.setNodeMarkup(splitListItemPos, undefined, { ...splitListItemNode.attrs, voters: [] }))
    return true
  }
  return false
}
